import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { environment } from 'src/environments/environment';
import { ObrasProjeto } from '../../models/obras-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ObrasProjetoService } from '../../services/obras-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { Router } from '@angular/router';
import { HistoryService } from '../../services/history.service';

@Component({
  selector: 'app-detalhe-projeto-obras-list',
  templateUrl: './detalhe-projeto-obras-list.component.html',
  styleUrls: ['./detalhe-projeto-obras-list.component.scss']
})
export class DetalheProjetoObrasListComponent extends BaseListComponent<ObrasProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  canCreate: boolean;
  obras: ObrasProjeto[];

  constructor(
    private myService: ObrasProjetoService,
    private pesquisaGeralService: PesquisaGeralService,
    private router: Router,
    private historyService: HistoryService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.canCreate = false;
      this.initLoadDataTable();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getListAll(this.idProjeto).subscribe((res) => {
        this.obras = res['tabela'];
        this.canCreate = res['canCreate'];
        this.loaded();
      })
    );
  }
}
